import { Injectable, Inject } from '@angular/core';
import { ConfigModel } from "../models/config.model";
import { BaseHttpResponse } from "../models/core.model";
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { LOGO, SALES_STATEMENT_SETTINGS } from '../constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ConfigService {
  private configSubject: BehaviorSubject<ConfigModel>;
    
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string,
  ) {
    this.configSubject = new BehaviorSubject<ConfigModel>(null);
  }  

  public getSettings() {
    return new Promise<void>((resolve, reject) => {
        this.http.get<ConfigModel>(this.apiUrl + 'config/ui')
          .subscribe({
            next: (response) => {
              this.configSubject.next(response);
              // sessionStorage.setItem(LOGO, response.model.logo);
              // sessionStorage.setItem(SALES_STATEMENT_SETTINGS, JSON.stringify(response.model));
              resolve();
            },
            error: (err) => reject(err)
          });
      });
  }
  
  public get settings() : ConfigModel {
    return this.configSubject.value;
  }
}